import { render, staticRenderFns } from "./RooftopUrls.vue?vue&type=template&id=c1b4485e&"
import script from "./RooftopUrls.vue?vue&type=script&lang=js&"
export * from "./RooftopUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports